import { ToutContentCard } from '@components/ToutContent';
import Section from '@repo/ui/src/components/Section';
import { ImageProps } from '@repo/ui/src/types/image';
import { ToutContentProps } from '@repo/ui/src/types/toutContent';
import { YoutubeLinkProps } from '@repo/ui/src/types/youtubeLink';

interface Props {
  cardBackground: ImageProps;
  playButtonLabel: string;
  toutContent: ToutContentProps;
  youtubeLink: YoutubeLinkProps;
}
const FeaturedVideo = ({ cardBackground, toutContent, youtubeLink }: Props) => {
  return (
    <Section gutterX gutterY className="tw-min-h-[85vh]">
      <ToutContentCard
        cardBackground={cardBackground}
        youtubeLink={youtubeLink}
        toutContent={toutContent}
        className="tw-m-auto tw-aspect-video lg:tw-max-w-[80vw]"
      />
    </Section>
  );
};

export default FeaturedVideo;
